<template>
  <div class="vue__app-root">
    <RouterView />
  </div>
</template>
